import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\HeaderTop.tsx.esbuild-plugin-linaria.css';
import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\HeaderTop.tsx.esbuild-plugin-windicss.css';
import { __ACCOUNTS_URL_BASE__ } from '@@urls';
import { css } from '@linaria/core';
import { mdiChevronRight, mdiRadioboxBlank, mdiRadioboxMarked } from '@mdi/js';
import deepEqual from 'fast-deep-equal';
import 'html-native-modal';
import 'html-native-modal/html-native-modal.css';
import { ComponentChildren } from 'preact';
import { memo } from 'preact/compat';
import { useState } from 'preact/hooks';
import type { ServiceUserAccount } from '../../../server/src/models';
import { ConnectionMethod, currentConnectionMethods, defaultConnectionMethods, setConnectionMethods } from '../connect';
import { i18n } from '../i18n';
import { QuotationDoodleHidden, QuotationDoodleInert } from '../QuotationDoodle';
import { loginUrl } from '../utils';
import { Dropdown } from './Dropdown';
import { DropdownMenu, MenuItemModel, menuItemSeparator } from './DropdownMenu';
import { Icon } from './Icon';
import { ServiceSuiteIcon } from './ServiceSuiteIcon';
export const HeaderBreadcrumbLink = memo(({
  href,
  title,
  children,
  openInNewTab
}: {
  href: string;
  title?: string;
  children: ComponentChildren;
  openInNewTab?: boolean;
}) => <a target={openInNewTab ? 'blank' : undefined} rel={openInNewTab ? 'noopener noreferrer' : undefined} href={href} title={title} class="text-inherit no-underline hover:underline">
      {children}
    </a>);
export const HeaderBreadcrumbDropdown = memo(({
  label,
  items,
  alignment
}: {
  label: string;
  items: readonly MenuItemModel[];
  alignment?: 'right';
}) => {
  const [isOpen, setOpen] = useState(false);
  return <>
        <Dropdown isOpen={isOpen} setOpen={setOpen} alignment={alignment} buttonClass={cssDropdownButtonClass} dropdownClass="font-400 text-color-default">
          {label}
          <DropdownMenu items={items} setOpen={setOpen} />
        </Dropdown>
      </>;
});
export const HeaderBreadcrumbDelimiter = memo(() => <Icon icon={mdiChevronRight} className="px-1" />);
const defaultUserMenuItems: readonly MenuItemModel[] = [{
  label: i18n.changePassword,
  link: `${__ACCOUNTS_URL_BASE__}/change-password/?continue=${encodeURIComponent(location.href)}`
}, {
  label: i18n.logout,
  onClick: async () => {
    topbar.show();
    await fetch(`${__ACCOUNTS_URL_BASE__}/api/logout`, {
      method: 'POST',
      mode: 'cors',
      credentials: 'include'
    });
    location.href = __ACCOUNTS_URL_BASE__;
  }
}];
const cssDropdownButtonClass = "c13m0twm";
const helpMenuItemsForUser: readonly MenuItemModel[] = [{
  newTab: true,
  label: i18n.about,
  link: 'https://genkei.co.jp/zumen/'
}, menuItemSeparator, {
  newTab: true,
  label: i18n.userManual,
  link: i18n.userManualUrl
}, {
  newTab: true,
  label: i18n.guestManual,
  link: i18n.guestManualUrl
}, menuItemSeparator, {
  newTab: true,
  label: i18n.contact,
  link: i18n.contactUrl
}, {
  newTab: true,
  label: i18n.termsOfUse,
  link: i18n.termsOfUseUrl
}, {
  newTab: true,
  label: i18n.privacyStatement,
  link: i18n.privacyStatementUrl
}];
const helpMenuItemsForGuest: readonly MenuItemModel[] = [...helpMenuItemsForUser, menuItemSeparator, {
  newTab: true,
  label: i18n.signUpForTrial,
  link: `${__ACCOUNTS_URL_BASE__}/trial/`
}];
const canConfigureConnection = localStorage.getItem('zumeco:connection:configurable') === '1';
const connectionMethodNameMap: Readonly<Record<ConnectionMethod, string>> = {
  ws: 'WebSocket',
  sse: 'SSE',
  polling: 'Polling'
};
const connectionMenuItems: readonly MenuItemModel[] = ([[defaultConnectionMethods, 'Default'], [['ws'], connectionMethodNameMap.ws], [['sse'], connectionMethodNameMap.sse], [['polling'], connectionMethodNameMap.polling]] as const).map(([methods, label]) => ({
  label,
  icon: deepEqual(methods, currentConnectionMethods) ? mdiRadioboxMarked : mdiRadioboxBlank,
  onClick: () => setConnectionMethods(methods)
}));
export const HeaderTop = memo(({
  currentUser,
  userMenuItems,
  connectionMethod,
  showsLoginLink,
  children
}: {
  currentUser?: Partial<ServiceUserAccount>;
  userMenuItems?: readonly MenuItemModel[];
  connectionMethod?: ConnectionMethod;
  showsLoginLink?: boolean;
  children?: any;
}) => {
  const tenant = currentUser?.tenants?.[currentUser.primary_tenant_id!];
  return <div class="h-22px flex items-center z-1 relative pl-6 pr-4 font-size-14px bg-primary text-white">
        <QuotationDoodleInert>
          <h2 class="font-size-inherit mr-2">
            <HeaderBreadcrumbLink href={__ACCOUNTS_URL_BASE__} title="GENKEI Cloud">
              <ServiceSuiteIcon size={14} color="white" />
            </HeaderBreadcrumbLink>
          </h2>
          <h2 class="font-size-inherit">
            <HeaderBreadcrumbLink href="/folders/" children={i18n.serviceName} />
          </h2>
        </QuotationDoodleInert>
        {children}

        <div class="flex-1" />

        {currentUser && tenant?.zumeco?.license?.trialContractEndAt && !tenant.zumeco.license.paidContractStartAt && <div class="mx-2">
            <HeaderBreadcrumbLink href={`${__ACCOUNTS_URL_BASE__}/purchase/`} children={i18n.signUpForPaid} openInNewTab />
          </div>}

        <HeaderBreadcrumbDropdown label={i18n.help} items={currentUser?.primary_tenant_id ? helpMenuItemsForUser : helpMenuItemsForGuest} alignment="right" />

        {canConfigureConnection && <HeaderBreadcrumbDropdown label={connectionMethod ? connectionMethodNameMap[connectionMethod] : '接続方法'} items={connectionMenuItems} alignment="right" />}

        {currentUser && <QuotationDoodleHidden>
            <HeaderBreadcrumbDropdown label={currentUser.name || currentUser.email || 'Guest'} items={userMenuItems ?? defaultUserMenuItems} alignment="right" />
          </QuotationDoodleHidden>}

        {!!showsLoginLink && !currentUser && <HeaderBreadcrumbLink href={loginUrl()} children={i18n.login} />}
      </div>;
});